import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './services.css'

const Services = (props) => {
  return (
    <div
      id={props.servicesId}
      className={`services-container1 thq-section-padding scroll-target ${props.rootClassName} `}
    >
      <div className="services-thq-max-width-elm thq-section-max-width">
        <div className="services-container2 thq-grid-2">
          <div className="services-thq-section-header-elm">
            <h2 className="thq-heading-2">Відкрийте потенціал наших послуг</h2>
            <p className="thq-body-large">
              Зв’яжіться з нами будь-яким зручним способом — ми завжди готові
              допомогти вам у найкоротший термін.
            </p>
            <div className="services-thq-actions-elm">
              <a
                href="tel:+380977316850"
                className="services-thq-button-elm thq-button-animated thq-button-filled"
              >
                <span className="thq-body-small">Зробити виклик</span>
              </a>
            </div>
          </div>
          <div className="services-container3">
            <div className="services-container4 thq-card">
              <h2 className="thq-heading-2">
                {props.step1Title ?? (
                  <Fragment>
                    <span className="services-text26">Request Assistance</span>
                  </Fragment>
                )}
              </h2>
              <span className="services-text11 thq-body-small">
                {props.step1Description ?? (
                  <Fragment>
                    <span className="services-text27">
                      Contact Evac via phone or online form to request towing
                      services.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="services-text12 thq-heading-3">01</label>
            </div>
            <div className="services-container5 thq-card">
              <h2 className="thq-heading-2">
                {props.step2Title ?? (
                  <Fragment>
                    <span className="services-text22">
                      Receive Confirmation
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="services-text14 thq-body-small">
                {props.step2Description ?? (
                  <Fragment>
                    <span className="services-text24">
                      Evac will confirm your request and provide an estimated
                      arrival time for assistance.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="services-text15 thq-heading-3">02</label>
            </div>
            <div className="services-container6 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title ?? (
                  <Fragment>
                    <span className="services-text28">
                      Professional Response
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="services-text17 thq-body-small">
                {props.step3Description ?? (
                  <Fragment>
                    <span className="services-text25">
                      A team of courteous professionals will be dispatched to
                      your location for quick assistance.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="services-text18 thq-heading-3">03</label>
            </div>
            <div className="services-container7 thq-card">
              <h2 className="thq-heading-2">
                {props.step4Title ?? (
                  <Fragment>
                    <span className="services-text29">Satisfied Customers</span>
                  </Fragment>
                )}
              </h2>
              <span className="services-text20 thq-body-small">
                {props.step4Description ?? (
                  <Fragment>
                    <span className="services-text23">
                      Read testimonials from satisfied customers who have
                      experienced Evac&apos;s reliable and efficient towing
                      services.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="services-text21 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Services.defaultProps = {
  rootClassName: '',
  step2Title: undefined,
  step4Description: undefined,
  step2Description: undefined,
  step3Description: undefined,
  servicesId: '',
  step1Title: undefined,
  step1Description: undefined,
  step3Title: undefined,
  step4Title: undefined,
}

Services.propTypes = {
  rootClassName: PropTypes.string,
  step2Title: PropTypes.element,
  step4Description: PropTypes.element,
  step2Description: PropTypes.element,
  step3Description: PropTypes.element,
  servicesId: PropTypes.string,
  step1Title: PropTypes.element,
  step1Description: PropTypes.element,
  step3Title: PropTypes.element,
  step4Title: PropTypes.element,
}

export default Services
